import * as React from "react";
import { Notice, Separator, Button } from "telia-front-react";
class PaymentFailedNotice extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { title, description, retryButtonLabel, closeButtonLabel } = this.props;
    return /* @__PURE__ */ React.createElement(Notice, { type: "error", direction: "vertical" }, typeof title === "string" ? /* @__PURE__ */ React.createElement("h2", { className: "text__margin-none" }, title) : /* @__PURE__ */ React.createElement("h2", { className: "text__margin-half", dangerouslySetInnerHTML: title }), /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), /* @__PURE__ */ React.createElement("h4", { className: "text__margin-none" }, description), /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), this.props.onRetryButton && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Button,
      {
        text: retryButtonLabel,
        type: "expressive",
        onClick: this.props?.onRetryButton,
        iconRight: "#arrow-right"
      }
    ), /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" })), this.props.onCloseButton && /* @__PURE__ */ React.createElement(Button, { text: closeButtonLabel, variant: "secondary", onClick: this.props?.onCloseButton }));
  }
}
export {
  PaymentFailedNotice as default
};
